import { render, staticRenderFns } from "./Page3.vue?vue&type=template&id=086c9f6a&scoped=true&"
import script from "./Page3.vue?vue&type=script&lang=ts&"
export * from "./Page3.vue?vue&type=script&lang=ts&"
import style0 from "./Page3.vue?vue&type=style&index=0&id=086c9f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c9f6a",
  null
  
)

export default component.exports